<template>
    <div id="border_bottom"></div>
</template>

<script>
export default {};
</script>

<style scoped>
#border_bottom {
    border-bottom: 1px solid gray;
    width: 90%;
    margin: 0 auto;
}
</style>
